export default "__VITE_PUBLIC_ASSET__e5ab01f0__"